// DynamicClientComponent.js
import React, { useMemo, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useData } from "../../DataContext";
import ProductPage from "../product-page/product-page.js";
import ProductPage2 from "../product-page2/product-page2.js";

const DynamicClientComponent = () => {
  const { clients, loading } = useData();
  const { clientCode } = useParams();
  const navigate = useNavigate();
  const prevClientCodeRef = useRef(sessionStorage.getItem("prevClientCode")); // Get initial value from sessionStorage

  // Find the client based on the clientCode from the URL
  const client = useMemo(() => {
    return clients.clientConfig && clients.clientConfig.find(
      (c) => c.customerCode.toLowerCase() === clientCode.toLowerCase()
    );
  }, [clients.clientConfig, clientCode]);

  // If loading is true, do not navigate yet
  useEffect(() => {
    if (!loading && !client) {
      navigate("/error"); // Navigate to /error page if client is not found
    }
  }, [client, loading, navigate]);

  // If loading, show a loading message
  if (loading) {
    return <p></p>;
  }

  const isTemplate2 = client?.templateId === "2";

  const previousClient = prevClientCodeRef && prevClientCodeRef.current;
  // Function to set previous client code
  const setPreviousClient = (newPrevClient) => {
    prevClientCodeRef.current = newPrevClient;
    sessionStorage.setItem("prevClientCode", newPrevClient);
  };

  return client ? (
    isTemplate2 ? (
      <ProductPage2 client={client} previousClient={previousClient} setPreviousClient={setPreviousClient} />
    ) : (
      <ProductPage client={client} previousClient={previousClient} setPreviousClient={setPreviousClient} />
    )
  ) : null; // Render nothing while navigating
};

export default DynamicClientComponent;